export const TOKEN_KEY = '@token';
export const ID_KEY = '@idkey';
export const USER_NAME = '@username';
